import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import useCommonStore from '../../hooks/useCommonStore';

const IsLogin = observer(({ on, off }) => {
  const commonStore = useCommonStore();
  const [isLogin, setIsLogin] = useState(true);

  useEffect(() => {
    commonStore.isLogin().then((res) => {
      if (res.code === 200) {
        setIsLogin(true);
      } else {
        setIsLogin(false);
      }
    });
  }, []);

  useEffect(() => {
    if (!commonStore.loginCheck) {
      commonStore.isLogin().then((res) => {
        if (res.code === 200) {
          setIsLogin(true);
        } else {
          setIsLogin(false);
        }
      });
    }
  }, [commonStore.loginCheck]);

  if (isLogin) {
    return !!on ? on : null;
  } else {
    return !!off ? off : null;
  }
});

export default IsLogin;
